import { COLORS } from '../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');

  return {
    cardRoot: {
      borderRadius: 0,
      minHeight: '50vh',
    },
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
      color: COLORS.WHITE,
      textAlign: 'center',
      borderRadius: '0px 0px',
      fontSize: '1.25rem',
      fontWeight: 600,
      padding: 15,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    cardContentRoot: {
      paddingTop: 30,
      [minSm]: {
        paddingLeft: 30,
        paddingRight: 30,
      },
    },
    button: {
      marginTop: '200px',
    },
    flexContainer: {
      [minSm]: {
        display: 'flex',
      },
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      width: '100%',
    },
    itemCenter: {
      [minSm]: {
        flex: '0 1 auto',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      },
    },
    itemRight: {
      [minSm]: {
        flex: '0 1 auto',
        marginLeft: 'auto',
        display: 'block',
      },
    },
  };
};

export default styles;
